import React, { useState } from "react";
import IconLink from "./IconLink";
import { Box } from "@mui/material";
import Terminal from "./Terminal";
import "./modal.css";

function PortfolioBlock(props) {
  const { image, live, sourceClient, sourceServer, title, quickDoc } = props;

  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  function aboutMeText() {
    return (
      <>
        <p>{quickDoc}</p>
      </>
    );
  }

  return (
    <>
      {isOpen && (
        <div className="dialog-overlay">
          <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
            <Terminal text={aboutMeText()} closeModal={closeModal} />
          </div>
        </div>
      )}
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Box component={"img"} src={image} alt={"mockup"} />
        <h1 style={{ fontSize: "2rem" }}>{title}</h1>
        <Box
          className={"portfolio"}
          display={"flex"}
          flexDirection={{
            xs: "column",
            sm: "column",
            md: "column",
            lg: "row",
          }}
          gap={"0.5rem"}
          alignItems={"center"}
          fontSize={"1.5rem"}
          py={"2rem"}
        >
          <Box
            p={1}
            border={"2px solid black"}
            borderRadius={"25px"}
            onClick={openModal}
          >
            <IconLink title={"Quick Doc"} icon={"fa fa-safari"} />
          </Box>
          <Box p={1} border={"2px solid black"} borderRadius={"25px"}>
            <IconLink link={live} title={"Live"} icon={"fa fa-safari"} />
          </Box>
          <Box p={1} border={"2px solid black"} borderRadius={"25px"}>
            <IconLink
              link={sourceClient}
              title={"Client Code"}
              icon={"fa fa-code"}
            />
          </Box>
          <Box p={1} border={"2px solid black"} borderRadius={"25px"}>
            <IconLink
              link={sourceServer}
              title={"Server Code"}
              icon={"fa fa-code"}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default PortfolioBlock;
